import { useEffect } from "react";
import FaqSection from "../components/FaqSections";
import HeroSection from "../components/home/heroSection";
import ClientSlider from "../components/home/ClientSlider";
import AboutSection from "../components/home/aboutSection";
import FeatureSection from "../components/home/FeatureSection";
import SkillSection from "../components/home/skillSelection";
import EnterpriseExpertise from "../components/home/EnterpriseExpertise";
import ServicesSection from "../components/home/serviceSection";
import TestimonialSection from "../components/home/TestimonialSection";
import TeamSection from "../components/home/TeamSection";
import BlogSection from "../components/home/blogSection";
import ProductsTabSection from "../components/home/ProductsTabSection";
import SolutionsSection from "../components/home/SolutionsSection";
import Seo, { organizationSchema } from "../components/Seo";

declare global {
  interface Window {
    Swiper: any;
  }
}

function Home() {
  useEffect(() => {
    const sliders = [
      {
        selector: ".client-slider-active",
        config: {
          slidesPerView: "auto",
          loop: true,
          spaceBetween: 130,
          speed: 3000,
          autoplay: {
            delay: 1,
            disableOnInteraction: false,
          },
        },
      },
      {
        selector: ".work-slider-active",
        config: {
          slidesPerView: "auto",
          loop: true,
          spaceBetween: 10,
          speed: 3000,
          autoplay: {
            delay: 0,
          },
        },
      },
      {
        selector: ".testimonial-slider-active",
        config: {
          effect: "cards",
          grabCursor: true,
          perSlideOffset: 50,
          rotate: false,
          perSlideRotate: 10,
          navigation: {
            prevEl: ".testimonial-button-prev",
            nextEl: ".testimonial-button-next",
          },
        },
      },
    ];

    const interval = setInterval(() => {
      if (!window.Swiper) return;

      sliders.forEach(({ selector, config }) => {
        const element = document.querySelector(selector);
        if (element && !element.classList.contains("swiper-initialized")) {
          new window.Swiper(selector, config);
        }
      });

      const allInitialized = sliders.every(({ selector }) =>
        document
          .querySelector(selector)
          ?.classList.contains("swiper-initialized")
      );

      if (allInitialized) clearInterval(interval);
    }, 200);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Seo
        title="MindSyncX"
        description="Enterprise AI and full-stack engineering. Production systems across autonomous agents, computer vision, voice, business messaging, infrastructure telemetry and hospitality operations."
        path="/"
        structuredData={organizationSchema}
      />
      <link rel="stylesheet" href="/assets/css/master-web-agency.css" />
      <main>
        {/* hero area start  */}
        <HeroSection />
        {/* hero area end  */}
        {/* clients area start  */}
        <ClientSlider />
        {/* clients area end  */}
        {/* platform suite start — the six products, one panel each  */}
        <ProductsTabSection />
        {/* platform suite end  */}
        {/* solutions start — the same catalog, cut by industry and capability  */}
        <SolutionsSection />
        {/* solutions end  */}
        {/* about area start  */}
        <AboutSection />
        {/* about area end  */}
        {/* feature area start  */}
        <FeatureSection />
        {/* feature area end  */}
        {/* skill area start  */}
        <SkillSection />
        {/* skill area end  */}
        {/* eterprise area start  */}
        <EnterpriseExpertise />
        {/* eterprise area end  */}
        {/* The legacy work slider stood here. It navigated to /product-details
            via router state — a route with no shareable URL, now removed — and
            its ids are the old CMS project ids, which do not match the product
            slugs. ProductsTabSection covers the same ground with live data and
            real links, so this is not a section that went missing. */}
        {/* service area start  */}
        <ServicesSection />
        {/* service area end  */}
        {/* testimonial area start  */}
        <TestimonialSection />
        {/* testimonial area end  */}
        {/* team area start  */}
        <TeamSection />
        {/* team area end  */}
        {/* faq area start  */}
        <FaqSection />
        {/* faq area end  */}
        {/* contact area start  */}
        {/* <section className="contact-area">
          <div className="container">
            <div className="contact-area-inner section-spacing">
              <div className="shape-1">
                <img src="/assets/imgs/shape/img-s-70.webp" alt="shape" loading="lazy" decoding="async" />
              </div>
              <div className="section-content">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2 className="section-title has_text_move_anim">
                      Embark on Your AI Journey experience with MindSyncX
                    </h2>
                  </div>
                </div>
                <div className="btn-wrapper has_fade_anim">
                  <a
                    href="/contact"
                    className="wc-btn wc-btn-underline btn-text-flip"
                  >
                    {" "}
                    <span data-text="Let's Create the Future Together">
                      Let's Create the Future Together
                    </span>{" "}
                    <img
                      src="/assets/imgs/icon/arrow-right-half-light.webp"
                      alt="" loading="lazy" decoding="async" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* contact area end  */}
        {/* blog area start  */}
        < BlogSection />
        {/* blog area end  */}
      </main>
    </>
  );
}

export default Home;
